<template>
  <div class="altrama-extension vivaticket-widget">
    <loading loader="svg" :active.sync="isLoading" :opacity="0.8" :height="200" :width="200" color="#5c7990"
      :can-cancel="false" :is-full-page="false">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" height="200" width="200" fill="#5c7990">
                <rect x="1" y="13" width="4" height="4">
                    <animate attributeName="width" attributeType="XML" values="4; 6; 4" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="height" attributeType="XML" values="4; 6; 4" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="x" attributeType="XML" values="1; 0; 1" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="y" attributeType="XML" values="13; 12; 13" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1"
                        calcMode="linear" repeatCount="indefinite"></animate>
                </rect>
                <rect x="10" y="13" width="6" height="6">
                    <animate attributeName="width" attributeType="XML" values="6; 4; 6" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="height" attributeType="XML" values="6; 4; 6" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="x" attributeType="XML" values="10; 11; 10" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="y" attributeType="XML" values="12; 13; 12" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1"
                        calcMode="linear" repeatCount="indefinite"></animate>
                </rect>
                <rect x="20" y="13" width="3" height="3">
                    <animate attributeName="width" attributeType="XML" values="4; 6; 4" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="height" attributeType="XML" values="4; 6; 4" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="x" attributeType="XML" values="21; 20; 21" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="y" attributeType="XML" values="13; 12; 13" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1"
                        calcMode="linear" repeatCount="indefinite"></animate>
                </rect>
      </svg>      
    </loading>

    <div>
      <div class="filter-wrapper d-flex">
        Mostra le date con almeno il seguente numero di posti
        <div class="d-flex">
          <div class="d-flex col-20">
              <button class="col-5" v-on:click="refreshFilterQuantity(-1)" :disabled="filterStatus">-</button>
              <input type="number" min="0" :value="quantity" :disabled="filterStatus" v-on:input="quantityFilterChange">
              <button class="col-5" v-on:click="refreshFilterQuantity(1)":disabled="filterStatus">+</button>
          </div>
          <div :class="[!filterStatus?'':'pressed','apply-button col-10']" v-on:click="applyButton()">
              {{filterStatus?'Rimuovi':'Applica'}}
          </div>
        </div>
      </div>

      <vc-calendar class="custom-calendar max-w-full" ref="calendar" :masks="masks" :attributes="attributes"
        disable-page-swipe is-expanded @update:from-page="pageChange">
        <template v-slot:day-content="{ day, attributes }">
          <div class="vivaticket-day">
            <div class="load-slot" v-for="attr in attributes" :key="attr.key" @click="loadSlot(attr.key)"></div>
            <span v-if="(Array.isArray(day.attributes) && typeof day.attributes[0].highlight != 'undefined')" class='selected-day vivaticket-day-label'>{{ day.day }}</span>
            <span v-else class='vivaticket-day-label'>{{ day.day }}</span>
          </div>
        </template>
      </vc-calendar>
      <div class="hour-wrapper" v-show="hourStatus()">
        <div class="calendar-title">orari</div>
        <div class="d-flex flex-wrap hour-slot">
          <div class="col-lg-15 col-sm-30" v-for="hour in slots" v-bind:key="hour">
            <div v-if="hour.available==='slot-available'" :class="hour.class" v-on:click="loadReduction(hour.date,hour.hour)">
              {{hour.hour}}
            </div>
            <div v-else :class="hour.class">
              {{hour.hour}}
            </div>
          </div>
        </div>
      </div>
      <div class="reduction-wrapper" v-show="reductionStatus()">
        <div class="calendar-title">tipologia</div>
        <div class="d-flex flex-wrap reduction-slot">
          <div class="availability-wrapper mx-auto" v-show="(availability>0)">Posti disponibili: {{availability}}</div>
          <div class="col-lg-30" v-for="reduction in reductions" v-bind:key="reduction">
            <div class='d-flex flex-wrap'>
              <div :class="[reduction.class, 'col-13']">
                {{reduction.reduction}}
              </div>
              <div v-if="reduction.class==='reduction-available'" class="col-8">
                €{{reduction.price}} 
              </div>
              <div v-if="reduction.class==='reduction-available'" class="col-9 d-flex">
                <button v-on:click="refreshQuantity(reduction.id,-1)">-</button>
                <input :id="reduction.id" type="number" min="0" :value="reduction.quantity" v-on:input="quantityChange">
                <button v-on:click="refreshQuantity(reduction.id,1)">+</button>
              </div>

              <div v-if="reduction.class==='reduction-not-available'" class="col-17">
                  ESAURITO
              </div>              
            </div>
          </div>
        </div>
      </div>

      <div class="price-wrapper" v-show="addCartStatus()">
          <span>prezzo:</span> €{{total.toFixed(2)}}
      </div>

      <div class="add-cart-wrapper" v-show="addCartStatus()" v-on:click="addCart()">
        aggiungi al carrello
        <svg xmlns="http://www.w3.org/2000/svg" id="carrello" width="16" height="16" viewBox="0 0 20 20">
          <path id="Tracciato_165" data-name="Tracciato 165" d="M8.514,20a1.8,1.8,0,1,1,1.8-1.8,1.8,1.8,0,0,1-1.8,1.8"
            fill="#040405"></path>
          <path id="Tracciato_166" data-name="Tracciato 166"
            d="M8.049,14.261A2.607,2.607,0,0,1,5.5,12.154L4.134,5.32c-.008-.033-.015-.066-.02-.1L3.459,1.948H.974A.974.974,0,0,1,.974,0H4.258A1.077,1.077,0,0,1,5.3.783L5.967,4.1H19.026a.973.973,0,0,1,.957,1.156L18.67,12.147a2.625,2.625,0,0,1-2.616,2.113H8.049M6.408,6.128l1.117,5.583a.7.7,0,0,0,.652.525h7.8a.64.64,0,0,0,.669-.524l1.064-5.584Z"
            fill="#040405"></path>
          <path id="Tracciato_167" data-name="Tracciato 167" d="M15.6,20a1.8,1.8,0,1,1,1.795-1.8A1.8,1.8,0,0,1,15.6,20"
            fill="#040405"></path>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VCalendar from "v-calendar";

var $ = window.jQuery;

Vue.use(VCalendar, {
  componentPrefix: "vc",
});

export default {
  components: {},
  computed: {
    isLoading: function () {
      return this.loadingResource || this.loadingResults;
    },
  },

  props: ["default_attribute", "post_id","post_slug","day","month","year","hour","reduction"],

  created() {
    //this.loadDay();
  },

  mounted(){
      var calendar=this.$refs.calendar;
      if (!(this.day===undefined || this.month===undefined || this.year===undefined || this.hour===undefined)){
        if (this.loadFromAttribute===true){
          calendar.move({ month: parseInt(this.month), year: parseInt(this.year) });
          this.loadDay(this.month, this.year);   
        }
      }
  },

  updated() {
    $("select").selectpicker(); //per la multiselect
    this.$jQueryWrapSelect(); //singole select
  },

  data() {
    const month = new Date().getMonth();
    const year = new Date().getFullYear();

    return {
      availability:0,
      quantity:1,
      currentQuantity:1,
      filterStatus:false,
      loadFromAttribute:true,
      currentMonth: new Date().getMonth() + 1,
      currentYear: new Date().getFullYear(),
      loadingResource: false,
      loadingResults: false,
      masks: {
        weekdays: "WWW",
      },
      attributes: [],
      slots: [],
      reductions: [],
      total:0,
    };
  },
  methods: {
    pageChange(obj) {
      console.log(obj);
      if ((!(this.day===undefined || this.month===undefined || this.year===undefined || this.hour===undefined)) && this.loadFromAttribute===true) {
        return;
      }
      this.currentMonth=obj.month;
      this.currentYear=obj.year,
      this.loadDay(obj.month, obj.year);        
    },

    loadDay(m, y) {
      if (m === undefined) {
        m = this.currentMonth;
      }
      if (y === undefined) {
        y = this.currentYear;
      }
      var self = this;
      self.attributes = [];
      self.slots = [];
      self.reductions = [];
      self.total = 0;
      self.loadingResource = true;
      axios({
        method: "get",
        url: this.default_attribute.concat(
          "/wp-json/api/v1/calendario-resources"
        ),
        params: {
          product: this.post_id,
          month: m,
          year: y,
          quantity: this.currentQuantity
        },
      })
        .then(function (response) {
          if (response.data.date.length > 0) {
            response.data.date.forEach((element) => {
              self.attributes.push({
                key: element.key,
                bar: element.bar,
                dates: new Date(element.year, element.month, element.day),
              });
            });
            if ((!(self.day===undefined || self.month===undefined || self.year===undefined || self.hour===undefined) && self.loadFromAttribute===true)) {
              self.loadSlot(self.day+'/'+self.month+'/'+self.year);
            }
            else{
              self.loadingResource = false;
            }     
          }
          else{
            self.loadFromAttribute=false;
            self.loadingResource = false;
          }
          
        })
        .catch(function (error) {});
    },

    loadSlot(date) {
      var self = this;

        var lastSelected=this.attributes.pop();
        lastSelected.highlight=false;
        this.attributes.push(lastSelected);

        var selectedElement = this.attributes.filter(function(el) {
        return el.key === date;
        });
        selectedElement=selectedElement[0];
        let selectedElementIndex=this.attributes.findIndex(function(el) {
        return el.key === date;
        });

        if (this.attributes[selectedElementIndex].bar=='red'){
          return;
        }        

        this.attributes.splice(selectedElementIndex, 1);
        selectedElement.highlight=true;
        this.attributes.push(selectedElement);
    
      self.slots = [];
      self.reductions = [];
      self.total = 0;
      self.loadingResource = true;
      axios({
        method: "get",
        url: this.default_attribute.concat("/wp-json/api/v1/slots-resources"),
        params: {
          product: this.post_id,
          date: date,
          quantity: this.currentQuantity
        },
      })
        .then(function (response) {
          if (response.data.slots.length > 0) {
            response.data.slots.forEach((element) => {
              element.class=element.available;
              self.slots.push(element);
            });
            if ((!(self.day===undefined || self.month===undefined || self.year===undefined || self.hour===undefined) && self.loadFromAttribute===true)) {
              self.loadReduction(self.day+'/'+self.month+'/'+self.year,self.hour);
            } 
            else{
              self.loadingResource = false;
            }    
          }
          else{
            self.loadingResource = false;
            self.loadFromAttribute=false;
          }

        })
        .catch(function (error) {});
    },

    loadReduction(date, h) {
      var self = this;
      var tempSlots = [];
      this.slots.forEach((element) => {
        element.class = element.available;
        tempSlots.push(element);
      });


      var selectedElement = tempSlots.filter(function (el) {
        return el.date === date && el.hour === h;
      });
      selectedElement = selectedElement[0];
      let selectedElementIndex = tempSlots.findIndex(function (el) {
        return el.date === date && el.hour === h;
      });

      tempSlots[selectedElementIndex].class = tempSlots[selectedElementIndex].available +" hour-selected";
      this.slots = [];
      tempSlots.forEach((element) => {
        this.slots.push(element);
      });

      self.reductions = [];
      self.loadingResource = true;
      axios({
        method: "get",
        url: this.default_attribute.concat("/wp-json/api/v1/reduction-resources"),
        params: {
          product: this.post_id,
          date: date,
          hour: h,
          quantity: this.currentQuantity
        },
      })
        .then(function (response) {
          if (response.data.reduction.length > 0) {
            self.availability=response.data.quantity;
            response.data.reduction.forEach((element) => {
              element.class=element.available;
              element.quantity=0;
              self.reductions.push(element);
            });
            if ((!(self.day === undefined || self.month === undefined || self.year === undefined || self.hour === undefined) && self.loadFromAttribute === true)) {
              self.selectReduction(self.reduction);
              self.loadFromAttribute = false;
            }  
          }
          else {
            self.loadFromAttribute = false;
          }
          self.loadingResource = false;
        })
        .catch(function (error) { });
    },

    selectReduction(reduction){
      var tempReductions = [];
      this.reductions.forEach((element) => {
        element.class = element.available;
        tempReductions.push(element);
      });

      var selectedElement = tempReductions.filter(function (el) {
        return el.reduction === reduction;
      });
      selectedElement = selectedElement[0];
      let selectedElementIndex = tempReductions.findIndex(function (el) {
        return el.reduction === reduction;
      });
      console.log(selectedElementIndex);

      tempReductions[selectedElementIndex].class = tempReductions[selectedElementIndex].available + " reduction-selected";
      this.reductions = [];
      tempReductions.forEach((element) => {
        this.reductions.push(element);
      });
    },

    hourStatus(){
        return this.slots.length>0;
    },

    reductionStatus(){
        return this.reductions.length>0;
    },    

    addCartStatus(){
      return this.total>0;
    },

    refreshQuantity(id,quantity){
      var self=this;
      var totalQuantity=0;
      self.reductions.forEach((element) => {
        totalQuantity=totalQuantity + element.quantity;
      });
      var item = this.reductions.find(obj => {
        return obj.id === id
      });
      if (item.quantity<1 && quantity<0){
        item.quantity=0;
      }
      else{
        if ((totalQuantity+quantity)<=this.availability){
          item.quantity=item.quantity+quantity;
        }
      }
      this.total=0;
      self.reductions.forEach((element) => {
        if ('price' in element){
          self.total=parseFloat(self.total + (element.quantity*element.price));
        }
      });
    },

    refreshFilterQuantity(quantity){
      if (this.quantity<2 && quantity<0){
        this.quantity=1;
      }
      else{
        this.quantity=this.quantity+quantity;
      }
    },

    quantityChange({type,target}){
      var item = this.reductions.find(obj => {
        return obj.id == target.id
      });
      var self=this;
      var totalQuantity=0;
      self.reductions.forEach((element) => {
        totalQuantity=totalQuantity + element.quantity;
      });
      if ((totalQuantity-item.quantity+parseInt(target.value))<=this.availability){
        item.quantity=parseInt(target.value);
      }
      else{
        item.quantity=this.availability-(totalQuantity-item.quantity);
      }
      this.total=0;
      self.reductions.forEach((element) => {
        if ('price' in element){
          self.total=parseFloat(self.total + (element.quantity*element.price));
        }
      });      
    },

    quantityFilterChange({type,target}){
      console.log(target.value);
      console.log(parseInt(target.value)>0);
      if (parseInt(target.value)>0){
        this.quantity = parseInt(target.value);
      }
      else{
        this.quantity=1;
      }
    },

    applyButton(){
      if (this.filterStatus){
        this.quantity=1;
        this.currentQuantity=1;
      }
      else{
        this.currentQuantity=this.quantity;
      }
      this.filterStatus=!this.filterStatus;
      
      this.loadDay(this.month, this.year);  
    },

    addCart(){
      var self=this;
      var bodyFormData = new FormData();
      bodyFormData.append('action','add_to_cart_callback');
      bodyFormData.append('reduction',JSON.stringify(this.reductions));
      this.loadingResource = true;
      axios({
        method: "post",
        url: this.default_attribute.concat("/wp-admin/admin-ajax.php"),
        data: bodyFormData,
      })
      .then(function (response) {
        self.slots=[];
        self.reductions=[];
        self.total=0;
        self.filterStatus=false;
        self.quantity=1;
        self.currentQuantity=1;
        $(".product").before(function() {
          return "<div class='woocommerce-notices-wrapper'><div class='woocommerce-message' role='alert'><a href='"+self.default_attribute.concat("/carrello/")+"' tabindex='1' class='button wc-forward'>Visualizza carrello</a> I biglietti sono stati aggiunti al tuo carrello.</div></div>";
        });
        var lastSelected=self.attributes.pop();
        lastSelected.highlight=false;
        self.attributes.push(lastSelected);
        self.loadingResource = false;
      })
      .catch(function (response) {

      })
    }
  },
};
</script>